const navigationHr = {
    "menu_editor": "Jelovnik ",
    "settings": "Postavke",
    "payment_settings": "Postavke plaćanja",
    "user_management": "Upravljanje korisnicima",
    "logout": "Odjava",
    "subscription": "Pretplata",
    "new_restaurant": "Stvori novi restoran",
    "privacy_policy": "Pravila o privatnosti",
    "terms_and_conditions": "Uvjeti i odredbe",
    "statistics": "Statistika",
    "mozrest": "Voditelj recenzija",
    "signup": "Prijavi se"
};

export default navigationHr;
